import React from 'react';
import './Home.css';
import BannerImage from '../../assets/banner/home.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faUsers, faCommentDots } from '@fortawesome/free-solid-svg-icons';

export default function Home() {

    // Icons
    const faClipboardIcon = <FontAwesomeIcon icon={faClipboardList} />
    const faUsersIcon = <FontAwesomeIcon icon={faUsers} />
    const faCommentDotsIcon = <FontAwesomeIcon icon={faCommentDots} />

  return (
    <>
    <section id="home">
        <div className="banner_image"></div>
        <div className="container">
            <div className="banner_outer">
            <div className="col">
                          <h3 className="title">
                              WE PROVIDE <span>COMPREHENSIVE SERVICES</span>
                          </h3>
                          <p>We specialize in offering secretarial services, consulting, training, and voucher sales for platforms like Netflix, DSTV, and international mobile SIM cards, tailored to your needs.</p>
                          <div className="btn_wrapper">
                              <a className="btn" href="/">Get Started</a>
                          </div>
           </div>

                <div className="col">
                    <div className="sub_banner_image">
                        <img src={BannerImage} alt="Banner_image" />
                    </div>
                    <div className="banner_style_1">
                        {faClipboardIcon}
                        <h4>Secretarial Services</h4>
                    </div>
                    <div className="banner_style_1 banner_style_2">
                        {faUsersIcon}
                        <h4>Expert Consulting</h4>
                    </div>
                    <div className="banner_style_1 banner_style_3">
                        {faCommentDotsIcon}
                        <h4>Training & Support</h4>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}
